import { createApi } from '@reduxjs/toolkit/query/react';
import { HttpMethod } from '@vision/ui/enums';
import { ApiResponse, LlmHealthStatus, LlmModel, LlmModelsResponse } from '@vision/ui/interfaces';
import { createHttpExtraOptions } from '../utils';
import { axiosBaseQuery } from './base.service';

export const LlmManagementService = createApi({
  reducerPath: 'LlmManagementService',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getLlmModels: builder.query<ApiResponse<LlmModelsResponse>, { nodeId: string; aiModelId: string }>({
      query: ({ nodeId, aiModelId }) => ({
        url: `/v2/accounts/${nodeId}/llm_management/${aiModelId}/models`,
        method: HttpMethod.GET,
      }),
    }),
    getLlmHealth: builder.query<ApiResponse<LlmHealthStatus>, { nodeId: string; aiModelId: string }>({
      query: ({ nodeId, aiModelId }) => ({
        url: `/v2/accounts/${nodeId}/llm_management/${aiModelId}/health`,
        method: HttpMethod.GET,
      }),
    }),
    activateLlmModel: builder.mutation<ApiResponse<LlmModel>, { nodeId: string; aiModelId: string; modelId: string }>({
      query: ({ nodeId, aiModelId, modelId }) => ({
        url: `/v2/accounts/${nodeId}/llm_management/${aiModelId}/activate`,
        method: HttpMethod.POST,
        data: { model: modelId },
        extraOptions: createHttpExtraOptions({
          notification: {
            translationMessageKey: 'http.message.llmManagement.activateModel.{{status}}',
          },
        }),
      }),
    }),
    deactivateLlmModel: builder.mutation<ApiResponse<LlmModel>, { nodeId: string; aiModelId: string; modelId: string }>(
      {
        query: ({ nodeId, aiModelId, modelId }) => ({
          url: `/v2/accounts/${nodeId}/llm_management/${aiModelId}/deactivate`,
          method: HttpMethod.POST,
          data: { model: modelId },
          extraOptions: createHttpExtraOptions({
            notification: {
              translationMessageKey: 'http.message.llmManagement.deactivateModel.{{status}}',
            },
          }),
        }),
      },
    ),
  }),
});

export const {
  useLazyGetLlmModelsQuery,
  useLazyGetLlmHealthQuery,
  useActivateLlmModelMutation,
  useDeactivateLlmModelMutation,
} = LlmManagementService;
